export function joinUrlPath(baseUrl: string, path: string) {
  const normalizedPath = String(path || "").trim();
  if (!normalizedPath) {
    return String(baseUrl || "").trim();
  }

  const pathWithLeadingSlash = normalizedPath.startsWith("/")
    ? normalizedPath
    : `/${normalizedPath}`;
  const normalizedBaseUrl = String(baseUrl || "").trim().replace(/\/+$/g, "");
  if (!normalizedBaseUrl) {
    return pathWithLeadingSlash;
  }
  return `${normalizedBaseUrl}${pathWithLeadingSlash}`;
}
